/* src/app/shared/components/ag-date-picker/date-double-box/date-double-box.component.scss */
.main-container {
  position: absolute;
  z-index: 4;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #222222;
}
.custom-datepicker {
  padding: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 16px;
  background: #ffffff;
  overflow: hidden;
  border-radius: 16px;
}
.placement-top {
  bottom: 0px;
}
.placement-bottom {
  top: 0px;
}
.placement-right {
  right: 101%;
}
.placement-zero-right {
  right: 0%;
}
.placement-zero-left {
  left: 0%;
}
.placement-left {
  left: 101%;
}
.placement-top-left {
  top: 0px;
  left: 101%;
}
.placement-top-right {
  top: 0px;
  right: 101%;
}
.placement-bottom-left {
  bottom: 52px;
  left: 101%;
}
.placement-bottom-right {
  bottom: 52px;
  left: 101%;
}
.placement-bottom-just-left {
  right: 0;
}
.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 58px;
}
.header-reverse {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 58px;
}
.image {
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.label {
  font-family: "Poppins-SemiBold";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
td {
  width: 36px;
  height: 36px;
  margin: 2px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}
td:not(:has(.in-month)):hover {
  cursor: default;
  background: transparent;
}
td:hover {
  border-radius: 8px;
  background: #f2f2f2;
}
.no-hover {
  cursor: default;
}
.no-hover:hover {
  background: transparent;
}
th {
  width: 18px;
  height: 18px;
  margin: 7px 9px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.br-line {
  height: 90%;
  left: 33px;
  top: 24px;
  width: 1px;
  background: #dfdfdf;
  position: absolute;
  z-index: 2;
}
.button-area {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px;
}
.calendar {
  position: relative;
  padding-top: 24px;
  overflow: hidden;
}
.week {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #a6a6a6;
  margin: 0;
}
.not-in-month {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #a6a6a6;
  margin: 0;
  padding: 4px 7px;
}
.in-month {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
  margin: 0;
  padding: 4px 7px;
}
.first-last-date {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  background-color: #222222 !important;
  color: #ffffff;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border-top: 1px solid #222222;
  border-bottom: 1px solid #222222;
  padding: 4px 7px;
}
.first-date {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  background-color: #222222 !important;
  color: #ffffff;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  padding: 0;
  width: 36px;
  height: 36px;
  padding: 4px 7px;
}
.last-date {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  background-color: #222222 !important;
  color: #ffffff;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #f2f2f2;
  padding: 0;
  width: 36px;
  height: 36px;
  padding: 4px 7px;
}
.white {
  color: #ffffff !important;
}
.selected {
  background-color: #e4d7f3;
}
.divider {
  height: 1px;
  width: 100%;
  background-color: #dfdfdf;
  margin-top: 8px;
}
/*# sourceMappingURL=date-double-box.component.css.map */
